module.exports = __webpack_public_path__ + "static/media/sj.d08937cb.svg";